import {DEFAULT_REDIRECT, SHOW_HTML_IN_MENU, SHOW_HIDDEN_FIELDS} from '../config/config.js'
import {PERMS} from '../config/permissions'

// шаблоны
import MainLayout from '../common/layout/main-layout.vue'
import AuthLayout from '../common/layout/auth-layout.vue'
import AccountUserProfileLayout from '../app/account/UserProfileLayout.vue'

// main
import MainError from '../app/main/Error.vue'

// авторизация/регистрация
import AuthLogin from '../app/auth/Login.vue'
import AuthRegisterSetPassword from '../app/auth/RegisterSetPassword.vue'
import AuthRequestResetPassword from '../app/auth/RequestResetPassword.vue'

// личный кабинет пользователя
const AccountUserProfile = () => import(/* webpackChunkName: "sverd.account" */ '../app/account/UserProfile.vue')

// карта
const GeoObjects = () => import(/* webpackChunkName: "sverd.geo" */ '../app/geo/region.hmao/Objects.vue')
const GeoTreads = () => import(/* webpackChunkName: "sverd.geo" */ '../app/geo/Threads.vue')

// АТУ: административно терр устройств
const AtuObjects = () => import(/* webpackChunkName: "sverd.atu" */ '../app/atu/Objects.vue')
const AtuObjectUpdate = () => import(/* webpackChunkName: "sverd.atu" */ '../app/atu/region.hmao/ObjectUpdate.vue')

// целевые показатели
const TargetTargets = () => import(/* webpackChunkName: "sverd.target" */ '../app/target/Targets.vue')
const TargetTargetUpdate = () => import(/* webpackChunkName: "sverd.target" */ '../app/target/TargetUpdate.vue')

// отходообразователи
const GarbageIndividuals = () => import(/* webpackChunkName: "sverd.garbage" */ '../app/garbage/Individuals.vue')
const GarbageIndividualUpdate = () => import(/* webpackChunkName: "sverd.garbage" */ '../app/garbage/IndividualUpdate.vue')
const GarbageLegalEntities = () => import(/* webpackChunkName: "sverd.garbage" */ '../app/garbage/LegalEntities.vue')
const GarbageLegalEntityUpdate = () => import(/* webpackChunkName: "sverd.garbage" */ '../app/garbage/LegalEntityUpdate.vue')

// Отходообразователи
const SourcesWasteSources = () => import(/* webpackChunkName: "sourcesWaste" */ '../app/sources-waste/Sources.vue')
const SourcesWasteSourceUpdate = () => import(/* webpackChunkName: "sourcesWaste" */ '../app/sources-waste/SourceUpdate.vue')

// мсн: места сбора и накопления
const MsnSeparateCollections = () => import(/* webpackChunkName: "sverd.msn" */ '../app/msn/SeparateCollections.vue')
const MsnSeparateCollectionUpdate = () => import(/* webpackChunkName: "sverd.msn" */ '../app/msn/SeparateCollectionUpdate.vue')
const MsnWithContainers = () => import(/* webpackChunkName: "sverd.msn" */ '../app/msn/WithContainers.vue')
const MsnWithContainerUpdate = () => import(/* webpackChunkName: "sverd.msn" */ '../app/msn/WithContainerUpdate.vue')
const MsnWithoutContainers = () => import(/* webpackChunkName: "sverd.msn" */ '../app/msn/WithoutContainers.vue')
const MsnWithoutContainerUpdate = () => import(/* webpackChunkName: "sverd.msn" */ '../app/msn/WithoutContainerUpdate.vue')

// импорт файлов
const ImportImportExcel = () => import(/* webpackChunkName: "sverd.import" */ '../app/import/ImportExcel.vue')

// несанкцс свалки
const UnauthorizedHeaps = () => import(/* webpackChunkName: "sverd.unauthorized" */ '../app/unauthorized/Heaps.vue')
const UnauthorizedHeapUpdate = () => import(/* webpackChunkName: "sverd.unauthorized" */ '../app/unauthorized/HeapUpdate.vue')
const UnauthorizedWpf = () => import(/* webpackChunkName: "sverd.unauthorized" */ '../app/unauthorized/Wpf.vue')

// операторы
const RegistryOperators = () => import(/* webpackChunkName: "sverd.registry" */ '../app/registry/Operators.vue')
const RegistryOperatorAllUpdate = () => import(/* webpackChunkName: "sverd.registry" */ '../app/registry/OperatorAllUpdate.vue')
const RegistryObjects = () => import(/* webpackChunkName: "sverd.registry" */ '../app/registry/Objects.vue')
const RegistryObjectUpdate = () => import(/* webpackChunkName: "sverd.registry" */ '../app/registry/ObjectUpdate.vue')

// кадастры
const ClassifierFkko = () => import(/* webpackChunkName: "sverd.classifier" */ '../app/classifier/Fkko.vue')
const ClassifierFkkoUpdate = () => import(/* webpackChunkName: "sverd.classifier" */ '../app/classifier/FkkoUpdate.vue')
const ClassifierGarbage = () => import(/* webpackChunkName: "sverd.classifier" */ '../app/classifier/Garbage.vue')

// администрирование
const AccessUsers = () => import(/* webpackChunkName: "sverd.access" */ '../app/access/Users.vue')
const AccessUsersGroups = () => import(/* webpackChunkName: "sverd.access" */ '../app/access/UsersGroups.vue')
const AccessUserUpdate = () => import(/* webpackChunkName: "sverd.access" */ '../app/access/UserUpdate.vue')
const AccessUserGroupsUpdate = () => import(/* webpackChunkName: "sverd.access" */ '../app/access/UserGroupsUpdate.vue')
const AccessJournals = () => import(/* webpackChunkName: "sverd.access" */ '../app/access/Journals.vue')

// аналитика
const AnalyticCharts = () => import(/* webpackChunkName: "sverd.analytic" */ '../app/analytic/Charts.vue')
const AnalyticChart = () => import(/* webpackChunkName: "sverd.analytic" */ '../app/analytic/Chart.vue')
const AnalyticReports = () => import(/* webpackChunkName: "sverd.analytic" */ '../app/analytic/Reports.vue')
const AnalyticReportDownload = () => import(/* webpackChunkName: "sverd.analytic" */ '../app/analytic/ReportDownload.vue')
const AnalyticReportRevegetation = () => import(/* webpackChunkName: "sverd.analytic" */ '../app/analytic/ReportRevegetation.vue')

// разработка
const DevelopmentSettingUpdate = () => import(/* webpackChunkName: "sverd.development" */ '../app/development/SettingUpdate.vue')

// citizen appeals
const CitizenAppeals = () => import(/* webpackChunkName: "citizen" */ '../app/citizen/Appeals.vue')
const CitizenAppealsMap = () => import(/* webpackChunkName: "citizen" */ '../app/citizen/AppealsMap.vue')
const CitizenAppealUpdate = () => import(/* webpackChunkName: "citizen" */ '../app/citizen/AppealUpdate.vue')

// naviagtion
const NavigationControlRoutesMap = () => import(/* webpackChunkName: "navigationControl" */ '../app/navigation-control/region.hmao/RoutesMap.vue')
const NavigationControlRoutes = () => import(/* webpackChunkName: "navigationControl" */ '../app/navigation-control/Routes.vue')
const NavigationControlRouteUpdate = () => import(/* webpackChunkName: "navigationControl" */ '../app/navigation-control/RouteUpdate.vue')

// путевые листы - waybill
const WaybillWaybillGroups = () => import(/* webpackChunkName: "waybill" */ '../app/waybill/WaybillGroups.vue')
const WaybillWaybillUpdate = () => import(/* webpackChunkName: "waybill" */ '../app/waybill/WaybillUpdate.vue')

// расчет тарифа
const CalculationRegionalTariffs = () => import(/* webpackChunkName: "calculation" */ '../app/calculation/RegionalTariffs.vue')
const CalculationRegionalTariffFirstUpdate = () => import(/* webpackChunkName: "calculation" */ '../app/calculation/RegionalTariffFirstUpdate.vue')
const CalculationRegionalTariffNextUpdate = () => import(/* webpackChunkName: "calculation" */ '../app/calculation/RegionalTariffNextUpdate.vue')
const CalculationRegionalTariff = () => import(/* webpackChunkName: "calculation" */ '../app/calculation/RegionalTariff.vue')

// car park
const CarParkCars = () => import(/* webpackChunkName: "carPark" */ '../app/car-park/region.hmao/Cars.vue')

// управление персоналом
const StaffManagementEmployees = () => import(/* webpackChunkName: "staffManagement" */ '../app/staff-management/Employees.vue')
const StaffManagementEmployeeUpdate = () => import(/* webpackChunkName: "staffManagement" */ '../app/staff-management/EmployeeUpdate.vue')

// Контракты
const RegistryContracts = () => import(/* webpackChunkName: "sverd.registry" */ '../app/registry/Contracts.vue')
const RegistryContractsUpdate = () => import(/* webpackChunkName: "sverd.registry" */ '../app/registry/ContractsUpdate.vue')

// Маршруты
const RoutesRoutes = () => import(/* webpackChunkName: "routes" */ '../app/routes/Routes.vue')
const RoutesSchedule = () => import(/* webpackChunkName: "routes" */ '../app/routes/Schedule.vue')

// верстка
const reestrPage = () => import(/* webpackChunkName: "sverd.verstka" */ '../components/pages/verstka/reestr.vue')
const navigationControlPage = () => import(/* webpackChunkName: "sverd.verstka" */ '../components/pages/verstka/navigation-control.vue')
const navigationControlCarPage = () => import(/* webpackChunkName: "sverd.verstka" */ '../components/pages/verstka/navigation-control-car.vue')
const waybillCardPage = () => import(/* webpackChunkName: "sverd.verstka" */ '../components/pages/verstka/waybill-card.vue')
const routesPage = () => import(/* webpackChunkName: "sverd.verstka" */ '../components/pages/verstka/routes.vue')
const routeOnePage = () => import(/* webpackChunkName: "sverd.verstka" */ '../components/pages/verstka/route-one.vue')
const routeSchedulePage = () => import(/* webpackChunkName: "sverd.verstka" */ '../components/pages/verstka/route-schedule.vue')

const verstka = [
  {
    path: 'reestr', name: 'verstka.reestr',
    meta: {title: 'Реестр'},
    component: reestrPage
  },
  {
    path: 'waybill-card', name: 'verstka.waybillCard',
    meta: {title: 'Путевые листы'},
    component: waybillCardPage
  },
  {
    path: 'navigation-control', name: 'verstka.navigationControlPage',
    meta: {title: 'Навигационный контроль'},
    component: navigationControlPage
  },
  {
    path: 'navigation-control-car', name: 'verstka.navigationControlCarPage',
    meta: {title: 'Навигационный контроль'},
    component: navigationControlCarPage
  },
  {
    path: 'routes', name: 'verstka.routesPage',
    meta: {title: 'Маршруты'},
    component: routesPage
  },
  {
    path: 'route-one', name: 'verstka.routeOnePage',
    meta: {title: 'Маршруты'},
    component: routeOnePage
  },
  {
    path: 'route-schedule', name: 'verstka.routeSchedulePage',
    meta: {title: 'Маршрутные графики'},
    component: routeSchedulePage
  }
]
let verstkaRoutes = { path: '/verstka/', component: MainLayout, name: 'verstka', meta: {title: 'Страницы верстки', number: '13'},
  redirect: { name: 'verstka.reestr' },
  children: verstka
}

let routes = [
  { path: '/main', name: 'main', component: MainLayout, meta: {requiresAuth: false},
    children: [
      {path: 'error', name: 'main.error', component: MainError, meta: {requiresAuth: false, title: 'Ошибка', noRouteCheck: true}}
    ]
  },
  { path: '/auth', name: 'auth', component: AuthLayout, meta: {requiresAuth: false},
    children: [
      {path: 'login', name: 'auth.login', component: AuthLogin, alias: '/login', meta: {requiresAuth: false, title: 'Вход'}},
      {path: 'set-password', name: 'auth.registerSetPassword', component: AuthRegisterSetPassword, alias: '/set-password', meta: {requiresAuth: false, havePerms: [PERMS.CREATE, PERMS.EDIT], title: 'Установка пароля'}},
      {path: 'request-reset-password', name: 'auth.requestResetPassword', component: AuthRequestResetPassword, alias: '/request-reset-password', meta: {requiresAuth: false, havePerms: [PERMS.CREATE, PERMS.EDIT], title: 'Восстановление пароля'}}
    ]
  },
  { path: '/terShema', component: MainLayout, name: 'geo', meta: {title: 'Территориальная схема', number: '01', requiresAuth: false},
    redirect: { name: 'geo.objects' },
    children: [
      {
        path: '/', component: GeoObjects, name: 'geo.objects', meta: {title: 'Карта объектов', requiresAuth: false},
        children: [
          {path: 'legal-entity/:id', name: 'geo.objects.legalEntity.update', component: GarbageLegalEntityUpdate, meta: {requiresAuth: false}},
          {path: 'individual-update/:id', name: 'geo.objects.individual.update', component: GarbageIndividualUpdate, meta: {requiresAuth: false}},
          {path: 'with-container-update/:id', name: 'geo.objects.withContainer.update', component: MsnWithContainerUpdate, meta: {requiresAuth: false}},
          {path: 'without-container-update/:id', name: 'geo.objects.withoutContainer.update', component: MsnWithoutContainerUpdate, meta: {requiresAuth: false}},
          {path: 'separate-update/:id', name: 'geo.objects.separate.update', component: MsnSeparateCollectionUpdate, meta: {requiresAuth: false}},
          {path: 'heap-update/:id', name: 'geo.objects.heap.update', component: UnauthorizedHeapUpdate, meta: {requiresAuth: false}},
          {path: 'unauth-update/:id', name: 'geo.objects.unauth.update', component: RegistryObjectUpdate, meta: {requiresAuth: false}},
          {path: 'object-update/:id', name: 'geo.objects.object.update', component: RegistryObjectUpdate, meta: {requiresAuth: false}},
          {path: 'operator-update/:id', name: 'geo.objects.operator.update', component: RegistryOperatorAllUpdate, meta: {requiresAuth: false}}
        ]
      },
      {
        path: 'potokShema', component: GeoTreads, name: 'geo.treads', meta: {title: 'Схема потоков', requiresAuth: false}
      }
    ]
  },
  { path: '/admTerUstr', component: MainLayout, name: 'atu', meta: {title: 'Административно-территориальное устройство', number: '02'},
    redirect: { name: 'atu.objects' },
    children: [
      {
        path: '', name: 'atu.objects', component: AtuObjects, meta: {title: 'Административно-территориальное устройство', hideInMenu: true},
        children: [
          {path: 'update/:id', name: 'atu.objects.update', component: AtuObjectUpdate}
        ]
      }
    ]
  },
  { path: '/targets', component: MainLayout, name: 'target', meta: {title: 'Целевые показатели', number: '03'},
    redirect: { name: 'target.targets' },
    children: [
      {
        path: '', name: 'target.targets', component: TargetTargets, meta:  {title: 'Целевые показатели', hideInMenu: true },
        children: [
          {path: 'create', name: 'target.targets.create', component: TargetTargetUpdate, meta:  {title: 'Целевые показатели'} },
          {path: 'update/:id', name: 'target.targets.update', component: TargetTargetUpdate, meta:  {title: 'Целевые показатели'} }
        ]
      }
    ]
  },
  { path: '/garbages', component: MainLayout, name: 'garbage', meta: {title: 'Отходообразователи', number: '04'},
    redirect: { name: 'garbage.legalEntities' },
    children: [
      {
        path: 'legal-entities', component: GarbageLegalEntities, name: 'garbage.legalEntities', meta: {title: 'Юридические лица'},
        children: [
          {path: 'create', name: 'garbage.legalEntities.create', component: GarbageLegalEntityUpdate},
          {path: 'update/:id', name: 'garbage.legalEntities.update', component: GarbageLegalEntityUpdate}
        ]
      },
      {
        path: 'individuals', component: GarbageIndividuals, name: 'garbage.individuals', meta: {title: 'Физические лица'},
        children: [
          {path: 'create', name: 'garbage.individuals.create', component: GarbageIndividualUpdate},
          {path: 'update/:id', name: 'garbage.individuals.update', component: GarbageIndividualUpdate}
        ]
      }
    ]
  },
  {
    path: '/sources-waste', component: MainLayout, name: 'sourcesWaste', meta: {title: 'Отходообразователи', number: '05'},
    redirect: {name: 'sourcesWaste.sources'},
    children: [
      {
        path: 'sources',
        component: SourcesWasteSources,
        name: 'sourcesWaste.sources',
        meta: {title: 'Отходообразователи', hideInMenu: true},
        children: [
          {path: 'create', name: 'sourcesWaste.sources.create', component: SourcesWasteSourceUpdate},
          {path: 'update/:id', name: 'sourcesWaste.sources.update', component: SourcesWasteSourceUpdate}
        ]
      }
    ]
  },
  { path: '/places/', component: MainLayout, name: 'msn', meta: {title: 'Места сбора и накопления', number: '06'},
    redirect: { name: 'msn.withContainers' },
    children: [
      {
        path: 'container', component: MsnWithContainers, name: 'msn.withContainers', meta: {title: 'Контейнерные площадки'},
        children: [
          {path: 'create', name: 'msn.withContainers.create', component: MsnWithContainerUpdate},
          {path: 'update/:id', name: 'msn.withContainers.update', component: MsnWithContainerUpdate}
        ]
      },
      {
        path: 'noContainer', component: MsnWithoutContainers, name: 'msn.withoutContainers', meta: {title: 'Бесконтейнерный сбор'},
        children: [
          {path: 'create', name: 'msn.withoutContainers.create', component: MsnWithoutContainerUpdate},
          {path: 'update/:id', name: 'msn.withoutContainers.update', component: MsnWithoutContainerUpdate}
        ]
      },
      {
        path: 'vtors', component: MsnSeparateCollections, name: 'msn.separateCollections', meta: {title: 'Пункты сбора вторсырья'},
        children: [
          {path: 'create', name: 'msn.separateCollections.create', component: MsnSeparateCollectionUpdate},
          {path: 'update/:id', name: 'msn.separateCollections.update', component: MsnSeparateCollectionUpdate}
        ]
      }
    ]
  },
  { path: '/svalki/', component: MainLayout, name: 'unauthorized', meta: {title: 'Несанкционированные свалки', number: '07'},
    redirect: { name: 'unauthorized.heaps' },
    children: [
      {
        path: '', component: UnauthorizedHeaps, name: 'unauthorized.heaps', meta: {title: 'Навалы мусора'},
        children: [
          {path: 'create', name: 'unauthorized.heaps.create', component: UnauthorizedHeapUpdate},
          {path: 'update/:id', name: 'unauthorized.heaps.update', component: UnauthorizedHeapUpdate}
        ]
      },
      {
        path: 'oro', component: UnauthorizedWpf, name: 'unauthorized.wpf', meta: {title: 'Несанкционированные ОРО'},
        children: [
          {path: 'create', name: 'unauthorized.wpf.create', component: RegistryObjectUpdate},
          {path: 'update/:id', name: 'unauthorized.wpf.update', component: RegistryObjectUpdate}
        ]
      }
    ]
  },
  { path: '/othObjects', component: MainLayout, name: 'garbageObjectRegistry', meta: {title: 'Реестр объектов по обращению с отходами', number: '08'},
    redirect: { name: 'registry.objects' },
    children: [
      { path: '', component: RegistryObjects, name: 'registry.objects', meta: {title: 'Реестр объектов по обращению с отходами', hideInMenu: true},
        children: [
          {path: 'create', name: 'registry.objects.create', component: RegistryObjectUpdate},
          {path: 'update/:id', name: 'registry.objects.update', component: RegistryObjectUpdate}
        ]
      }
    ]
  },
  { path: '/regisrty/', component: MainLayout, name: 'registry', meta: {title: 'Операторы', number: '09'},
    redirect: { name: 'registry.operators' },
    children: [
      {
        path: '', component: RegistryOperators, name: 'registry.operators', meta: {title: 'Операторы', hideInMenu: true},
        children: [
          {path: 'create', name: 'registry.operators.create', component: RegistryOperatorAllUpdate},
          {path: 'update/:id', name: 'registry.operators.update', component: RegistryOperatorAllUpdate}
        ]
      }
    ]
  },
  { path: '/contracts', component: MainLayout, name: 'contracts', meta: {title: 'Договоры', number: '10'},
    redirect: { name: 'contracts.contracts' },
    children: [
      {
        path: 'contracts', component: RegistryContracts, name: 'contracts.contracts', meta: {title: 'Договоры', hideInMenu: true},
        children: [
          {path: 'create', name: 'contracts.contracts.create', component: RegistryContractsUpdate},
          {path: 'update/:id', name: 'contracts.contracts.update', component: RegistryContractsUpdate}
        ]
      }
    ]
  },
  { path: '/analytics/', component: MainLayout, name: 'analytic', meta: {title: 'Аналитика', number: '11'},
    redirect: { name: 'analytic.charts' },
    children: [
      {path: 'chart/:chartId', component: AnalyticChart, name: 'analytic.chart', meta: {title: 'График', hideInMenu: true}},
      {path: 'charts', component: AnalyticCharts, name: 'analytic.charts', meta: {title: 'Аналитика', hideInMenu: true}},
      {
        path: 'reports', component: AnalyticReports, name: 'analytic.reports', meta: {title: 'Отчеты', hideInMenu: true},
        children: [
          {path: 'report/:reportId/:windowType', name: 'analytic.reports.report', component: AnalyticReportDownload, meta: {title: 'Отчеты'}},
          {path: 'report-revegetation', name: 'analytic.reports.reportRevegetation', component: AnalyticReportRevegetation, meta: {title: 'Отчет 2ТП (рекультивация)'} }
        ]
      }
    ]
  },
  { path: '/cadastre/', component: MainLayout, name: 'classifier', meta: {title: 'Кадастр отходов', number: '12'},
    redirect: { name: 'classifier.fkko' },
    children: [
      {path: '', component: ClassifierFkko, name: 'classifier.fkko', meta: {title: 'ФККО'},
        children: [
          {path: 'fkko-update/rootId-:rootId/pid-:pid/id-:id', name: 'classifier.fkko.update', component: ClassifierFkkoUpdate},
          {path: 'fkko-create/rootId-:rootId/pid-:pid', name: 'classifier.fkko.create', component: ClassifierFkkoUpdate}
        ]
      },
      {path: 'othod', component: ClassifierGarbage, name: 'classifier.garbage', meta: {title: 'Банк данных об отходах'}}
    ]
  },
  { path: '/admin/', component: MainLayout, name: 'access', meta: {title: 'Администрирование', number: '13'},
    redirect: { name: 'access.users' },
    children: [
      { path: '', component: AccessUsers, name: 'access.users', meta: {title: 'Пользователи'},
        children: [
          {path: 'create', name: 'access.users.create', component: AccessUserUpdate},
          {path: 'update/:id', name: 'access.users.update', component: AccessUserUpdate}
        ]
      },
      { path: 'users-groups', component: AccessUsersGroups, name: 'access.usersGroups', meta: {title: 'Группы пользователей'},
        children: [
          {path: 'create', name: 'access.usersGroups.create', component: AccessUserGroupsUpdate},
          {path: 'update/:id', name: 'access.usersGroups.update', component: AccessUserGroupsUpdate}
        ]
      },
      { path: 'journals', component: AccessJournals, name: 'access.journals', meta: {title: 'Журнал изменений'}},
    ]
  },
  /* {
    path: '/billing', component: MainLayout, name: 'billing', meta: {title: 'Биллинг', number: '14'},
    redirect: { name: 'billing.regionalOperatorInvoices' },
    children: [
      {
        path: 'regional-operator-invoices', component: BillingRegionalOperatorInvoices, name: 'billing.regionalOperatorInvoices', meta: {title: 'Счета'},
        children: [
          {path: 'create', name: 'billing.regionalOperatorInvoices.create', component: BillingRegionalOperatorInvoiceUpdate},
          {path: 'update/:id', name: 'billing.regionalOperatorInvoices.update', component: BillingRegionalOperatorInvoiceUpdate}
        ]
      }
    ]
  }, */
  {
    path: '/navigation-control', component: MainLayout, name: 'navigationControl', meta: {title: 'Навигационный контроль', number: '15'},
    redirect: { name: 'navigationControl.routesMap' },
    children: [
      {path: 'routes-map', component: NavigationControlRoutesMap, name: 'navigationControl.routesMap', meta: {title: 'Карта маршрутов'}},
      { path: 'routes-create', component: NavigationControlRouteUpdate, name: 'navigationControl.routes.update', meta: {title: 'Редактирование маршрута', hideInMenu: true}},
      { path: 'routes-update/:id', component: NavigationControlRouteUpdate, name: 'navigationControl.routes.create', meta: {title: 'Добавление маршрута', hideInMenu: true}},
      { path: 'routes', component: NavigationControlRoutes, name: 'navigationControl.routes', meta: {title: 'Маршруты Карты маршрутов', hideInMenu: !SHOW_HIDDEN_FIELDS}},
    ]
  },
  { path: '/waybill', component: MainLayout, name: 'waybill', meta: {title: 'Путевые листы', number: '16'},
    redirect: { name: 'waybill.waybillGroups' },
    children: [
      { path: 'waybill-groups', component: WaybillWaybillGroups, name: 'waybill.waybillGroups', meta: {title: 'Путевые листы', hideInMenu: true},
        /* children: [] */
      },
      {path: 'waybills/create', name: 'waybill.waybills.create', component: WaybillWaybillUpdate, meta: {hideInMenu: true}},
      {path: 'waybills/update/:id', name: 'waybill.waybills.update', component: WaybillWaybillUpdate, meta: {hideInMenu: true}}
    ]
  },
  { path: '/routes', component: MainLayout, name: 'routes', meta: {title: 'Маршруты', number: '17'},
    redirect: { name: 'routes.routes' },
    children: [
      { path: 'routes', component: RoutesRoutes, name: 'routes.routes', meta: {title: 'Маршруты'}},
      { path: 'schedule', component: RoutesSchedule, name: 'routes.schedule', meta: {title: 'Маршрутные графики'}}
    ]
  },
  { path: '/car-park', component: MainLayout, name: 'carPark', meta: {title: 'Автопарк', number: '18'},
    redirect: { name: 'carPark.cars' },
    children: [
      { path: 'cars', component: CarParkCars, name: 'carPark.cars', meta: {title: 'Автопарк', hideInMenu: true}
        /* children: [] */
      }
    ]
  },
  { path: '/staff-management', component: MainLayout, name: 'staffManagement', meta: {title: 'Управление персоналом', number: '19'},
    redirect: { name: 'staffManagement.employees' },
    children: [
      { path: 'employees', component: StaffManagementEmployees, name: 'staffManagement.employees', meta: {title: 'Управление персоналом', hideInMenu: true},
        children: [
          {path: 'create', name: 'staffManagement.employees.create', component: StaffManagementEmployeeUpdate},
          {path: 'update/:id', name: 'staffManagement.employees.update', component: StaffManagementEmployeeUpdate}
        ]
      }
    ]
  },
  {
    path: '/citizen', component: MainLayout, name: 'citizen', meta: {title: 'Обращения граждан', number: '20'},
    redirect: { name: 'citizen.appeals' },
    children: [
      {
        path: 'appeals-map', component: CitizenAppealsMap, name: 'citizen.appealsMap', meta: {title: 'Карта обращений'},
        children: [
          {path: 'create', name: 'citizen.appealsMap.create', component: CitizenAppealUpdate},
          {path: 'update/:id', name: 'citizen.appealsMap.update', component: CitizenAppealUpdate}
        ]
      },
      {
        path: 'appeals', component: CitizenAppeals, name: 'citizen.appeals', meta: {title: 'Реестр обращений'},
        children: [
          {path: 'create', name: 'citizen.appeals.create', component: CitizenAppealUpdate},
          {path: 'update/:id', name: 'citizen.appeals.update', component: CitizenAppealUpdate}
        ]
      }
    ]
  },
  {
    path: '/calculation', component: MainLayout, name: 'calculation', meta: {title: 'Расчет тарифа', number: '21'},
    redirect: {name: 'calculation.regionalTariffs'},
    children: [
      {
        path: 'regional-tariffs', component: CalculationRegionalTariffs, name: 'calculation.regionalTariffs', meta: {title: 'Расчет единого тарифа на услугу Регионального оператора'},
        children: [
          {path: 'first-update/:id', component: CalculationRegionalTariffFirstUpdate, name: 'calculation.regionalTariffs.firstUpdate', meta: {title: 'Расчет на первый год действия'}},
          {path: 'next-update/:id', component: CalculationRegionalTariffNextUpdate, name: 'calculation.regionalTariffs.nextUpdate', meta: {title: 'Расчет на последующие годы'}},
          {path: 'view/:id', component: CalculationRegionalTariff, name: 'calculation.regionalTariffs.view', meta: {title: 'Просмотр тарифа'}}
        ]
      }
    ]
  },
  {path: '/import', component: MainLayout, name: 'import', meta: {title: 'Импорт данных', number: ' ', hideInMenu: true},
    children: [
      { path: 'excel', component: ImportImportExcel, name: 'import.importExcel', meta: {title: 'Импорт даннных', hideInMenu: true}}
    ]
  },
  { path: '/profile', component: AccountUserProfileLayout, name: 'account', meta: {title: 'Личный кабинет', number: '13', hideInMenu: true},
    redirect: { name: 'account.userProfile' },
    children: [
      { path: '', component: AccountUserProfile, name: 'account.userProfile', meta: {title: 'Личный кабинет', hideInMenu: true}}
    ]
  },
  { path: '/development', component: MainLayout, name: 'development', meta: {title: 'Разработка', number: '0', hideInMenu: true},
    redirect: { name: 'development.settingUpdate' },
    children: [
      { path: 'setting-update', component: DevelopmentSettingUpdate, name: 'development.settingUpdate', meta: {title: 'Меню разработки', hideInMenu: true}}
    ]
  },
  {path: '*', redirect: DEFAULT_REDIRECT.default}
]

if (SHOW_HTML_IN_MENU && SHOW_HTML_IN_MENU === true) {
  routes.push(verstkaRoutes)
}

export default {
  /* mode: 'history', */
  linkActiveClass: 'active',
  routes: routes
}
